import React from 'react'

import * as Styled from './styled'

interface Props {
  placement: string
  className?: string
  hideAds?: boolean
}

export const Advert: React.FC<Props> = React.memo(
  ({ className = '', placement, hideAds }: Props) =>
    !hideAds ? (
      <div className={`adds-wrapper ${className}`} suppressHydrationWarning>
        <div id={`D_${placement}`} />
        <div id={`M_${placement}`} />
      </div>
    ) : null
)

export const FixedAdvert: React.FC<Props> = (props) => (
  <Styled.FixedPlacement>
    <Advert {...props} />
  </Styled.FixedPlacement>
)
